import { Component, OnInit } from '@angular/core';
import { FavoritesService, SavedCompound } from 'src/app/_services/favorites.service';

@Component({
  selector: 'app-my-favorites',
  templateUrl: './my-favorites.component.html',
  styleUrls: ['./my-favorites.component.css']
})
export class MyFavoritesComponent implements OnInit {
  favorites: SavedCompound[] = [];

  constructor(private favoritesService: FavoritesService) {}

  ngOnInit(): void {
    this.favoritesService.favorites$.subscribe(favs => {
      this.favorites = favs;
    });
  }

  remove(compoundId: string): void {
    this.favoritesService.toggle(compoundId, '');
  }

  compoundRoute(compoundId: string): string[] {
    return ['/compound_data', compoundId];
  }
}
